import { motion } from 'motion/react'
import { IoMdChatbubbles } from 'react-icons/io'
import { useTranslation } from 'react-i18next'

export default function FeedbackPopupTab({ onClick }) {
  const { t } = useTranslation()

  return (
    <motion.button
      type="button"
      onClick={onClick}
      initial={{ opacity: 0, scale: 0.7 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.7 }}
      transition={{ type: 'spring', stiffness: 400, damping: 22 }}
      className="group relative flex items-center gap-2 border-2 border-primary-600 bg-white py-2 pl-3 pr-4 font-bold text-primary-700 shadow-lg transition hover:bg-primary-600 hover:text-white"
    >
      <span className="absolute inset-0 -z-10 border-2 border-secondary-500 opacity-40 motion-safe:animate-ping" />
      <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-secondary-600 text-white transition group-hover:bg-white group-hover:text-primary-700">
        <IoMdChatbubbles size={16} />
      </span>
      <span className="text-sm">{t('your_opinion_matters')}</span>
    </motion.button>
  )
}
